import { app } from '../../../../app';
import { Controller } from './create-access-request.controller';

app.component('createAccessRequest', {
    controller: Controller,
    bindings: {
        companies: '<',
    },
    templateUrl: require('./create-access-request.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/access-requests/create/create-access-request.component.js